<template>
  <div
    id="account"
    class="grid-zone"
  >
    <section id="personnal_data">
      <div id="avatar_container">
        <Avatar
          :class="{ 'library-image': user.avatar_from_library, }"
          :ext-img="user.avatar"
          :img-name="user.avatar_from_library"
        />
        <ButtonClassic
          variant="special"
          :label="$t('compte.changer-davatar')"
          icon="left"
          color="primary"
          @click="$modal.show('modal_change_image')"
        >
          <template #left-icon>
            <UilUserSquare />
          </template>
        </ButtonClassic>
        <ModalChangeImage
          :user="user"
          :organisme-actuel="organismeActuel"
          @validate-img="$emit('validate-img', $event)"
        />
      </div>
      <div id="form_data">
        <h2 class="title s5 bold title-separator flex-vcenter">
          <span>{{ $t("compte.donnees-personnelles") }}</span>
        </h2>
        <form class="inputs-form">
          <InputClassic
            v-model="form.prenom"
            type="text"
            :label="$t('compte.prenom')"
            :placeholder="$t('compte.votre-prenom')"
            status="locked"
            disabled
            @blur="submitForm()"
          />
          <InputClassic
            v-model="form.nom"
            type="text"
            :label="$t('compte.nom')"
            :placeholder="$t('compte.votre-nom')"
            status="locked"
            disabled
            @blur="submitForm()"
          />
        </form>
        <ButtonClassic
          v-if="canChangePassword"
          variant="special"
          :label="$t('compte.modifier-votre-mot-de-passe')"
          icon="left"
          color="primary"
          balise-type="a"
          ext-link="https://cas.lde.fr/password/change"
        >
          <template #left-icon>
            <UilLockAccess />
          </template>
        </ButtonClassic>
      </div>
    </section>

    <section id="attributions">
      <h2 class="title s5 bold title-separator flex-vcenter">
        <span>{{ $t("compte.attributions") }}</span>
      </h2>
      <!-- @slot Emplacement pour les données de droite. -->
      <slot name="block-right" />
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ButtonClassic from "../../components/buttons/ButtonClassic.vue";
import InputClassic from "../../components/forms/InputClassic.vue";

import Avatar from "../../components/avatar/Avatar.vue";

import ModalChangeImage from "../../components/modals/ModalChangeImage.vue";

import { UilLockAccess, UilUserSquare } from "@lde/vue-unicons";

/**
 * Informations du profil de l'utilisateur.
 */
export default defineComponent({
  name: "Account",
  components: {
    ButtonClassic,
    InputClassic,
    Avatar,
    ModalChangeImage,
    UilLockAccess,
    UilUserSquare,
  },
  props: {
    /**
     * Informations de l'utilisateur.
     */
    user: {
      type: Object,
      required: true,
    },
    /**
     * Informations de l'organisme actuel.
     */
    organismeActuel: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Définit si l'utilisateur peut changer son mot de passe ou non.
     */
    canChangePassword: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * Déclenché à l'enregistrement de l'avatar.
     */
    "validate-img",
  ],
  data() {
    return {
      form: {
        nom: this.user.contact.nom,
        prenom: this.user.contact.prenom,
        email: this.user.contact.email,
      },
      emailHelper: {
        helper: "",
        status: "locked",
      },
    };
  },
  methods: {
    /**
     * Vérifie si le mail a la bonne syntaxe.
     */
    isEmailValid(email) {
      // eslint-disable-next-line max-len
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return (email === "") ? "" : !!(reg.test(email));
    },
    /**
     * Modifie les données de l'utilisateur selon les inputs.
     */
    submitForm() {
      if (!this.isEmailValid(this.form.email)) {
        this.emailHelper = {
          helper: this.$t("compte.adresse-soit-valide"),
          status: "error",
        };
        return;
      }
      this.emailHelper = {
        helper: "",
        status: "locked",
      };

      const user = { ...this.user };
      user.contact = { ...user.contact, ...this.form };

      const isSame = JSON.stringify(this.user.contact) === JSON.stringify(user.contact);
      if (!isSame) {
        this.$emit("submit-user", user);
      }
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/layout/account.scss";
</style>
